export const UI_SECTION_INFO_CUTOFF_DATE = new Date("2025-10-22");

const normalizeDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const normalized = new Date(value);
  return Number.isNaN(normalized.getTime()) ? null : normalized;
};

export const shouldShowUISectionInfo = ({
  uiSection,
  shownSections = {},
  trialPeriodStartDate,
  skipTrialStartGate = false,
}) => {
  if (!uiSection) {
    return false;
  }

  if (!skipTrialStartGate) {
    const normalizedTrialStartDate = normalizeDate(trialPeriodStartDate);

    if (!normalizedTrialStartDate) {
      return false;
    }

    if (normalizedTrialStartDate < UI_SECTION_INFO_CUTOFF_DATE) {
      return false;
    }
  }

  return shownSections?.[uiSection] !== true;
};
